'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<g id="my-projects-my-projects-46735" fill="none" fill-rule="evenodd"><g id="my-projects-Group-46735" transform="translate(2)" fill="#58595B" fill-rule="nonzero"><path d="M12 0l2 2h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2l2-2h6zM4 4H2v16h14V4h-2v1a1 1 0 0 1-.883.993L13 6H5a1 1 0 0 1-.993-.883L4 5V4zm10 12a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2h6zm-9 0a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h1zm9-4a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2h6zm-9 0a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h1zm9-4a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2h6zM5 8a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h1zm6.171-6H6.828l-.84.842a1 1 0 0 1 .005.041L6 3v1h6V3c0-.054.004-.107.012-.158L11.171 2z" id="my-projects-Combined-Shape-46735"/></g></g><!-- Filename: sourceSvg/my-projects/my-projects.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 22'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};